module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.9c46095.ttf";